import { ReactNode } from 'react'

import { type ServiceArea, ServiceAreaContext } from '@/components/molecules/shared/service-area'
import { cn } from '@/lib/utils'

interface CustomerPageWrapperProps {
  children: ReactNode
  className?: string
  stickyHeader?: ReactNode
  maxWidth?: 'default' | 'wide' | 'full'
  /**
   * The service this page belongs to. Puts `data-service` on the page, so its
   * chips, icon tiles and step nodes wear that service's accent, and the
   * page's `PageHeader` shows the service dot.
   */
  service?: ServiceArea
}

export function CustomerPageWrapper({
  children,
  className,
  stickyHeader,
  maxWidth = 'wide',
  service,
}: CustomerPageWrapperProps) {
  const maxWidthClasses = {
    default: 'max-w-7xl',
    wide: 'max-w-[1400px]',
    full: 'max-w-none',
  }

  return (
    <ServiceAreaContext.Provider value={service}>
      <div data-service={service} className="flex h-full flex-col">
        {stickyHeader && (
          <div data-sticky-header={true} className="shrink-0">
            <div className={cn('mx-auto px-4 sm:px-6 lg:px-8', maxWidthClasses[maxWidth])}>{stickyHeader}</div>
          </div>
        )}

        {/* pb-24: the chat bubble (fixed, 20px up, 56px tall) must never cover a page's last button. */}
        <div className="flex-1 overflow-y-auto">
          <div
            className={cn(
              'mx-auto',
              stickyHeader ? 'px-4 pt-4 pb-24 sm:px-6 lg:px-8 lg:pt-6' : 'px-4 pt-6 pb-24 sm:px-6 lg:px-8',
              maxWidthClasses[maxWidth],
              className,
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </ServiceAreaContext.Provider>
  )
}
